import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { PropertyService } from '../../services/property.service';
import { OrganizationService } from '../../services/organization.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CreatePropertyDialogComponent } from '../create-property-dialog/create-property-dialog.component';

@Component({
  selector: 'app-admin-landing',
  templateUrl: './admin-landing.component.html',
  styleUrls: ['./admin-landing.component.scss']
})
export class AdminLandingComponent implements OnInit, AfterViewInit {
  organization;
  attributes = [];
  selectedFile: File;
  properties = [];
  allProperties = []; // All properties (unfiltered)
  filteredProperties = []; // Filtered properties
  displayedProperties = []; // Paginated subset of filtered properties

  loading: boolean = true;
  private dataLoaded = false;
  private imageLoaded = false;
  leasedCount = 0;
  availableCount = 0;
  totalBalanceDue = 0;

  addpropcount=0;

  // Pagination
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize = 10;
  pageSizeOptions = [10, 20, 50];
  currentPage = 0;
  totalItems = 0;

  // Filters
  selectedStatus: string | null = null; // 'available', 'leased', or null for all
  searchText: string = '';
  propertyLeaseMap = new Map<string, boolean>(); // Cache: propertyId -> hasActiveLease

  constructor(private propertyService: PropertyService,
              private organizationService: OrganizationService,
              private authService: AuthService,
              public router: Router,
              private dialog: MatDialog) {}

  ngOnInit() {
    // Load organization
    this.organizationService.getOrganization().then((organization) => {
      this.organization = organization;
      this.imageLoaded = true; // Always set to true after organization loads (or fails)
      this.maybeCheckLoadingComplete();
    }).catch((error) => {
      console.error('Error loading organization:', error);
      this.imageLoaded = true; // Set to true so loading can complete
      this.maybeCheckLoadingComplete();
    });

    // Load attributes
    this.propertyService.getAdminAttributes().then((attributes) => {
      this.attributes = attributes || [];
    }).catch((error) => {
      console.error('Error loading attributes:', error);
      this.attributes = [];
    });

    // Clear cached properties
    this.propertyService.clearProperties();

    // Load properties
    this.propertyService.getProperties().then((properties) => {
      this.allProperties = properties || [];
      this.totalItems = this.allProperties.length;
      // Initialize filtered and displayed before lease checks
      this.filteredProperties = [...this.allProperties];
      this.updateDisplayedProperties();
      this.updateLeaseCounts(); // This will call applyFilters() when done
      this.updateTotalBalanceDue(); // Calculate total balance due
      this.dataLoaded = true;
      this.maybeCheckLoadingComplete();
    }).catch((error) => {
      console.error('Error loading properties:', error);
      this.allProperties = [];
      this.properties = [];
      this.filteredProperties = [];
      this.displayedProperties = [];
      this.totalItems = 0;
      this.leasedCount = 0;
      this.availableCount = 0;
      this.totalBalanceDue = 0;
      this.dataLoaded = true;
      this.maybeCheckLoadingComplete();
    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.page.subscribe((event: PageEvent) => {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.updateDisplayedProperties();
      });
      // Initialize displayed properties
      this.updateDisplayedProperties();
    } else {
      // If paginator not available yet, still update display
      this.updateDisplayedProperties();
    }
  }

  getProperties() {
    return this.propertyService.getProperties();
  }

  addPropertyAction() {
    const dialogRef = this.dialog.open(CreatePropertyDialogComponent, {
      width: '800px',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'mobile-dialog-panel',
      autoFocus: false,
      data: { attributes: this.attributes }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        // Refresh properties list
      this.propertyService.clearProperties();
      this.propertyService.getProperties().then((properties) => {
        this.allProperties = properties || [];
        this.totalItems = this.allProperties.length;
        this.propertyLeaseMap.clear(); // Clear lease cache
        this.updateLeaseCounts(); // This will call applyFilters() when done
        this.updateTotalBalanceDue(); // Update total balance due
      }).catch((error) => {
        console.error('Error refreshing properties:', error);
      });
      }
    });
  }

  editProperty(property) {
    if (!property || !property.id) return;
    this.router.navigate(['edit-property', property.id]);
  }

  onCancel(property) {
    if(!property.id) {
      // Remove the temporary property from the list when the user cancels
      const index = this.properties.indexOf(property);
      if(index > -1) {
        this.properties.splice(index, 1);
      }

      // keep the add property counter in sync
      if(this.addpropcount > 0) {
        this.addpropcount--;
      }

      this.propertyService.clearProperties();
    }
  }
    
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
      
    var reader = new FileReader();

    reader.readAsDataURL(this.selectedFile); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
        this.organization.marketingImageUrl = reader.result;
    }
      
    //console.log(this.organization);  
    this.organizationService.uploadImage(this.organization.name,this.selectedFile).then((msg) => {});
      
    /*const uploadData = new FormData();
    uploadData.append('myFile', this.selectedFile, this.selectedFile.name);
      
    
    this.http.post('my-backend.com/file-upload', uploadData, {
        reportProgress: true,
        observe: 'events'
    })
    .subscribe(event => {
        console.log(event); // handle event here
    });*/
  }  

  updateDataSave(){
    this.addpropcount--;
    if(this.addpropcount==0){
      this.organizationService.getOrganization().then((organization) => {
        this.organization = organization;
        if (!this.organization.marketingImageUrl) {
          this.imageLoaded = true;
        }
      });

      this.propertyService.getAdminAttributes().then((attributes) => {
        this.attributes = attributes;
      });

      this.propertyService.clearProperties();

      this.propertyService.getProperties().then((properties) => {
        this.allProperties = properties || [];
        this.totalItems = this.allProperties.length;
        this.propertyLeaseMap.clear();
        this.updateLeaseCounts(); // This will call applyFilters() when done
        this.dataLoaded = true;
        this.maybeCheckLoadingComplete();
      });
    }
  }

  updateDataDelete(){
    if(this.addpropcount==0){
      this.loading = true;
      this.propertyService.clearProperties();
      Promise.all([
        this.organizationService.getOrganization(),
        this.propertyService.getAdminAttributes(),
        this.propertyService.getProperties()
      ]).then(([organization, attributes, properties]) => {
        this.organization = organization;
        this.attributes = attributes;
        this.allProperties = properties || [];
        this.totalItems = this.allProperties.length;
        this.propertyLeaseMap.clear();
        this.updateLeaseCounts(); // This will call applyFilters() when done
        this.updateTotalBalanceDue(); // Update total balance due
        this.dataLoaded = true;
        if (!this.organization.marketingImageUrl) {
          this.imageLoaded = true;
        }
        this.maybeCheckLoadingComplete();
      });
    }
  }

  getImageUrl(path: string) {
    if (!path) {
      return '';
    }

    // convert legacy S3 URLs to API-served paths
    if (path.startsWith('http') && path.includes('amazonaws.com')) {
      const fileName = path.substring(path.lastIndexOf('/') + 1);
      path = `/v1/public/organization/image/${fileName}`;
    }

    if (path.startsWith('http') || path.startsWith('data:')) {
      return path;
    }
    return environment.apiBaseUrl + path;
  }

  onImageLoad() {
    this.imageLoaded = true;
    this.maybeCheckLoadingComplete();
  }

  onImageError() {
    this.imageLoaded = true;
    this.maybeCheckLoadingComplete();
  }

  private maybeCheckLoadingComplete() {
    if (this.dataLoaded && this.imageLoaded) {
      this.loading = false;
    }
  }

  updateLeaseCounts() {
    if (!this.allProperties || this.allProperties.length === 0) {
      this.leasedCount = 0;
      this.availableCount = 0;
      this.propertyLeaseMap.clear();
      return;
    }

    // Check active leases for all properties
    const leaseChecks = this.allProperties.map(property => {
      if (!property || !property.id) {
        return Promise.resolve({ id: null, hasLease: false });
      }
      return this.propertyService.getActiveLease(property).then(lease => {
        return { id: property.id, hasLease: !!lease };
      }).catch(() => {
        return { id: property.id, hasLease: false };
      });
    });

    Promise.all(leaseChecks).then(results => {
      this.propertyLeaseMap.clear();
      results.forEach(result => {
        if (result.id) {
          this.propertyLeaseMap.set(result.id, result.hasLease);
        }
      });
      this.leasedCount = results.filter(r => r.hasLease).length;
      this.availableCount = this.allProperties.length - this.leasedCount;
      // Re-apply filters after lease map is updated
      this.applyFilters();
    }).catch(error => {
      console.error('Error checking leases:', error);
      // Fallback to status-based counting
      this.leasedCount = this.allProperties.filter(p => {
        const status = p.status;
        return status && status !== 'FOR_LEASE' && status !== null && status !== undefined;
      }).length;
      this.availableCount = this.allProperties.length - this.leasedCount;
      this.applyFilters();
    });
  }

  getAvailableProperties() {
    return this.availableCount != null ? this.availableCount : 0;
  }

  getLeasedProperties() {
    return this.leasedCount != null ? this.leasedCount : 0;
  }

  // Filter and pagination methods
  applyFilters() {
    let filtered = [...this.allProperties];

    // Status filter
    if (this.selectedStatus) {
      if (this.selectedStatus === 'available') {
        filtered = filtered.filter(p => !this.propertyLeaseMap.get(p.id));
      } else if (this.selectedStatus === 'leased') {
        filtered = filtered.filter(p => this.propertyLeaseMap.get(p.id));
      }
    }

    // Search filter
    if (this.searchText && this.searchText.trim()) {
      const searchLower = this.searchText.toLowerCase().trim();
      filtered = filtered.filter(p => {
        const address = (p.addressLine1 || '').toLowerCase();
        const city = (p.city || '').toLowerCase();
        const state = (p.state || '').toLowerCase();
        const zip = (p.zipCode || '').toString().toLowerCase();
        return address.includes(searchLower) || 
               city.includes(searchLower) || 
               state.includes(searchLower) || 
               zip.includes(searchLower);
      });
    }

    this.filteredProperties = filtered;
    this.totalItems = filtered.length;
    this.currentPage = 0; // Reset to first page when filters change
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.updateDisplayedProperties();
  }

  updateDisplayedProperties() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedProperties = this.filteredProperties.slice(startIndex, endIndex);
    // Also update this.properties for the grid (for backward compatibility)
    this.properties = this.displayedProperties;
  }

  onStatusFilterChange(status: string | null) {
    this.selectedStatus = status;
    this.applyFilters();
  }

  onSearchChange(event: any) {
    this.searchText = event.target ? event.target.value : event;
    this.applyFilters();
  }

  clearFilters() {
    this.selectedStatus = null;
    this.searchText = '';
    this.applyFilters();
  }

  updateTotalBalanceDue() {
    if (!this.allProperties || this.allProperties.length === 0) {
      this.totalBalanceDue = 0;
      return;
    }

    // Fetch invoice summaries for all properties
    const balancePromises = this.allProperties
      .filter(p => p && p.id)
      .map(property => {
        return this.propertyService.getInvoiceSummary(property)
          .then((summary: any) => {
            return summary && summary.balanceDue ? parseFloat(summary.balanceDue) : 0;
          })
          .catch(() => 0); // Silently fail for individual properties
      });

    Promise.all(balancePromises).then(balances => {
      this.totalBalanceDue = balances.reduce((sum, balance) => sum + balance, 0);
    }).catch(error => {
      console.error('Error calculating total balance due:', error);
      this.totalBalanceDue = 0;
    });
  }
}

